/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type PipeTransform, Pipe } from '@angular/core';
import { CAPACITY_UNIT, UtilService } from '@dm/core';

/**
 * 转换类型
 */
enum TransformFormatE {
    /**
     * 容量转换
     */
    CAPACITY = 'capacity',
    /**
     * 数量转换
     */
    NUMBER = 'num'
}

enum CapacityUnitE {
    KB = 0,
    MB = 1,
    GB = 2,
}

@Pipe({ name: 'unitTransform' })
export class UnitTransformPipe implements PipeTransform {
    constructor(private util: UtilService) { }

    /**
    * 根据所选单位获取最大值
    */
    transform(curUnit: number, maxValue: number, format = TransformFormatE.CAPACITY): number {
        // 数量转换
        if (format === TransformFormatE.NUMBER) {
            return maxValue / curUnit;
        }

        // 容量转换
        const targetUitMap = {
            [CapacityUnitE.KB]: CAPACITY_UNIT.KB,
            [CapacityUnitE.MB]: CAPACITY_UNIT.MB,
            [CapacityUnitE.GB]: CAPACITY_UNIT.GB,
        };

        return this.util.adaptUnit(maxValue, CAPACITY_UNIT.KB, targetUitMap[curUnit]).value;
    }
}
